import styles from "./NumberInput.module.scss";

type Props = {
  label?: string,
  placeholder?: string,
  unit?: string,
  sign?: string,
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  min?: number;
  width?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  type?: string;
}

export const NumberInput = ({ label, placeholder, unit, sign, value, onChange, min, width, onKeyDown, disabled, type="number" }: Props) => {
  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>
        {label}
        <div className={styles.inputGroup}>
          {sign && <span className={styles.sign}>{sign}</span>}
          <input
            placeholder={placeholder}
            className={styles.input}
            value={value}
            onChange={onChange}
            min={min}
            style={{ width }}
            onKeyDown={onKeyDown}
            disabled={disabled}
            type={type}
          />
          {unit && <span className={styles.unit}>{unit}</span>}
        </div>
      </label>
    </div>
  );
};
